import { Box, Grid, Hidden, Typography } from '@mui/material';
import { triggerEvent } from '../../remote-education/remote-education-utils';

export const ContactUsMobile: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: 'white' }} paddingY={'60px'}>
      <Grid container columnSpacing={{ xs: '0px', md: '100px' }}>
        <Grid item xs={12} lg={6}>
          {/**<Box
            component={'div'}
            display={'flex'}
            justifyContent={{ xs: 'center', lg: 'end' }}
          >
            <Box width={{ xs: '220px', md: '320px' }}>
              <Box display={'flex'} justifyContent={'center'}>
                <Box
                  height={{ xs: '100px', lg: '221px' }}
                  width={{ xs: '100px', lg: '221px' }}
                  marginRight={{ xs: 1, sm: 2 }}
                  position={'relative'}
                >
                  <img
                    src={'/comunicate.png'}
                    alt="Logo de plan"
                    width={'100%'}
                    height={'100%'}
                    style={{ position: 'absolute', objectFit: 'contain' }}
                  />
                </Box>
              </Box>
            </Box>
          </Box> */}
        </Grid>
        <Grid item xs={12} lg={12}>
          <Box
            component={'div'}
            display={'flex'}
            justifyContent={{ xs: 'center' }}
          >
            <Box width={{ xs: '220px', sm: '320px' }}>
              <Box marginBottom={'20px'}>
                <Typography
                  textAlign={'center'}
                  fontFamily={'oswald'}
                  fontWeight={700}
                  textTransform={'uppercase'}
                  fontSize={{ xs: '22px', md: '40px' }}
                  lineHeight={{ xs: '30px', md: '48px' }}
                  paddingBottom={'16px'}
                >
                  Comunícate
                </Typography>
                <Typography
                  fontWeight={400}
                  textTransform={'lowercase'}
                  textAlign={'center'}
                  fontFamily={'manop'}
                  fontSize={{ xs: '18px', lg: '22px' }}
                  lineHeight={{ xs: '18px', lg: '22px' }}
                >
                  CON UN ASESOR PERSONAL PARA
                </Typography>
              </Box>
              <Hidden mdUp={true} mdDown={false}>
                <Grid container marginBottom={'20px'} alignItems={'center'}>
                  <Grid spacing={2} item xs={6} borderRight={'1px solid black'}>
                    <Typography
                      textAlign={'center'}
                      fontFamily={'manop'}
                      lineHeight={'19px'}
                    >
                      Planes <br /> corporativos <br /> especiales
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      textAlign={'center'}
                      fontFamily={'manop'}
                      lineHeight={'16px'}
                    >
                      Planes <br /> universitarios
                    </Typography>
                  </Grid>
                </Grid>
              </Hidden>
              <Hidden mdUp={false} mdDown={true}>
                <Box>
                  <ul
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <li
                      className="listRed"
                      style={{ paddingBottom: 16, width: '220px' }}
                    >
                      <Typography
                        fontSize={'22px'}
                        lineHeight={'24px'}
                        fontWeight={400}
                        fontFamily={'manop'}
                      >
                        Planes corporativos especiales
                      </Typography>
                    </li>
                    <li
                      className="listRed"
                      style={{ paddingBottom: 12, width: '220px' }}
                    >
                      <Typography
                        fontSize={'22px'}
                        lineHeight={'24px'}
                        fontWeight={400}
                        fontFamily={'manop'}
                      >
                        Planes Universitarios
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Hidden>
              <Box display={'flex'} justifyContent={'center'}>
                <Box
                  component={'a'}
                  href="https://wa.me/5215610190580"
                  onClick={() => {
                    triggerEvent('btn_com');
                  }}
                  target="_blank"
                  borderRadius={'5px'}
                  paddingTop={{ xs: '12px', lg: '12px' }}
                  paddingBottom={{ xs: '12px', lg: '10px' }}
                  width={'100%'}
                  style={{
                    backgroundColor: 'black',
                    textDecoration: 'none',
                  }}
                >
                  <Typography
                    fontFamily={'oswald'}
                    fontWeight={400}
                    color={'white'}
                    fontSize={{ xs: '18px', sm: '22px' }}
                    lineHeight={{ xs: '16px', sm: '22px' }}
                    textAlign={'center'}
                  >
                    ESCRÍBENOS
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
